__turbopack_context__.v({
  "counter": "N8HVxW_counter",
  "dots": "N8HVxW_dots",
  "overlay": "N8HVxW_overlay",
});
